import { render, staticRenderFns } from "./widget_voice_answered_call.vue?vue&type=template&id=6cd980b5&"
import script from "./widget_voice_answered_call.vue?vue&type=script&lang=js&"
export * from "./widget_voice_answered_call.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports